import React from 'react';

export default function EtapasTab() {
  return <p style={{ color: '#697180', fontSize: 14 }}>Etapas de produção — em breve (módulo de Produção).</p>;
}
